module.exports = __webpack_public_path__ + "static/media/CaviarDreams_Italic.e67f5c38.ttf";